module.exports = __webpack_public_path__ + "static/assets/3733f47ed2f589eca8b02d1f34d43ee4.png";